import { render, staticRenderFns } from "./procedure-users-avatar.vue?vue&type=template&id=54001d6e&"
import script from "./procedure-users-avatar.vue?vue&type=script&lang=js&"
export * from "./procedure-users-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports